export default function updateQuestionTag(state, action) {
  const { id, tag } = action.payload;
  state.questionList.forEach((question) => {
    if (question._id === id) {
      question.tag = tag;
    }
  });
}
